import React from "react";

const CandleManicureXp = () => {
  return (
    <div className="nailExtensionMaintain">
      <h5>Why Choose SCENT Salon for Your Candle Spa Manicure?</h5>
      <ul>
        <li>
          <h6>Expertise and Experience:</h6> At SCENT, our nail technicians are
          highly trained and experienced in providing a wide range of nail
          services, including the luxurious Candle Spa Manicure. We take pride
          in our attention to detail and commitment to excellence.
        </li>
        <li>
          <h6>High-Quality Products:</h6> We use only the finest products and
          tools to ensure the best results for our clients. Our selection of
          massage candles, scrubs, polishes, and hand creams are chosen for
          their quality and effectiveness.
        </li>
        <li>
          <h6>Relaxing Atmosphere:</h6> Our salon is designed to provide a
          peaceful and calming environment where you can escape from the demands
          of everyday life. From the soothing music to the tranquil decor, every
          detail is curated to enhance your spa experience.
        </li>
        <li>
          <h6>Personalized Service:</h6> We believe that every client is unique,
          and we tailor our services to meet your individual needs and
          preferences. Our goal is to provide a customized spa experience that
          leaves you feeling pampered and satisfied.
        </li>
        <li>
          <h6>Convenient Location: </h6>SCENT is conveniently located in
          Bangalore, making it easy for you to access our exceptional spa
          services. Whether you're a busy professional or a homemaker, we offer
          flexible appointment times to suit your schedule.
        </li>
      </ul>
    </div>
  );
};

export default CandleManicureXp;
